import React, { useState, useEffect, useRef } from 'react';
import SectionHeading from './ui/SectionHeading';

function TopBrands() {
  const brands = [
    { name: 'Gucci', logo: '/brands/gucci.svg', link: 'https://www.gucci.com' },
    { name: 'Prada', logo: '/brands/prada.svg', link: 'https://www.prada.com' },
    { name: 'Ray-Ban', logo: '/brands/ray-ban.svg', link: 'https://www.ray-ban.com' },
    { name: 'Oakley', logo: '/brands/oakley.svg', link: 'https://www.oakley.com' },
    { name: 'Tom Ford', logo: '/brands/tomford.svg', link: 'https://www.tomford.com' },
  ];

  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px', threshold: 0.2 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-white py-16 md:py-24" aria-labelledby="brands-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="brands-heading"
          eyebrow="Designer eyewear"
          title="Top brands"
          subtitle="Discover frames from houses known for craftsmanship and iconic style."
        />
        <ul className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10 md:gap-x-16">
          {brands.map((brand, index) => (
            <li
              key={brand.name}
              className={`transition-all duration-700 ease-out ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <a
                href={brand.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-2xl border border-transparent p-4 transition hover:border-slate-100 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2"
              >
                <img src={brand.logo} alt={`${brand.name} — official brand logo`} className="h-20 md:h-28" loading="lazy" />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TopBrands;
